package com.shadowings.gero.domain.model

// Special content types for combo quiz screens
class QuizComboFive : IQuizContent

class QuizThreeErrors : IQuizContent

// Spliced into the quiz page list right after the answer whose XP award crossed a level
// threshold — same insertion pattern as QuizComboFive, see QuizScreen's
// addExperienceAndCheckLevelUp. tokensGranted is normally 1, but can be >1 if a single XP award
// crossed more than one level threshold at once.
class QuizLevelUp(val level: Int, val tokensGranted: Int = 1) : IQuizContent

class FinalQuizScreen(
    val availableCharacters: List<Characters> = listOf(Characters.Alyn, Characters.Nilo)
) : IQuizContent

// Post-quiz pages shown only on the first completed quiz of the day, appended
// after FinalQuizScreen instead of a global dialog triggered by persisted/synced state.
class StreakCelebrationScreen(val strikeCount: Int) : IQuizContent

class ReviewPromptScreen : IQuizContent

class CalendarPromptScreen : IQuizContent

// Shown instead of the pages above when none of them qualify for this quiz completion (see
// QuizViewModel's eligibility check) — the feature-request poll shouldn't compete with those
// higher-priority moments, so it only appears as a fallback.
class FeaturePollScreen : IQuizContent

